// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3v9Tl","col":"CardReaderDesc_col__1fXJ_","label":"CardReaderDesc_label__2IpGE"};